// src/slices/sponsor/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// ================= GET ALL SPONSORS =================
export const getSponsors = createAsyncThunk("sponsor/getAll", async (CategoryId, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/sponsor/all`, { params: { CategoryId: CategoryId } });

    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
// ================= GET SPONSOR BY ID =================
export const getSponsorById = createAsyncThunk("sponsor/getById", async (id, thunkAPI) => {
  try {
    const res = await axios.get(`${API_URL}/sponsor/${id}`);
    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data || err.message);
  }
});

export const addSponsor = createAsyncThunk("sponsor/add", async (payload, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/sponsor/from-user`, payload);

    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});
